import { render, staticRenderFns } from "./updatePWD.vue?vue&type=template&id=486c581d&scoped=true"
import script from "./updatePWD.vue?vue&type=script&lang=js"
export * from "./updatePWD.vue?vue&type=script&lang=js"
import style0 from "./updatePWD.vue?vue&type=style&index=0&id=486c581d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c581d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486c581d')) {
      api.createRecord('486c581d', component.options)
    } else {
      api.reload('486c581d', component.options)
    }
    module.hot.accept("./updatePWD.vue?vue&type=template&id=486c581d&scoped=true", function () {
      api.rerender('486c581d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/organization/newAccount/updatePWD.vue"
export default component.exports